import React, { Component, Fragment } from 'react'
import { observer } from 'mobx-react'
import classNames from 'classnames'

import { isEmpty } from '@elo-kit/utils/validators.utils'

import { LoadingSpinner } from '@elo-kit/components/loading-spinner/LoadingSpinner'
import EloModal from 'ui/EloModal'

import { SIZES } from '@elo-kit/constants/general.constants'
import { QUIZ_ATTEMPT_STATUSES } from 'constants/quiz.constants'
import { EloOrCustomButton } from 'utils/themes.utils'

@observer
class QuizResultModal extends Component {
  render() {
    const {
      courseViewsStore: { toggleQuizResultModal, continueCourse, toggleQuizResults, handleRetakeQuiz },
      quizzesStore,
      defaultTheme,
    } = this.props
    const { item: quiz } = quizzesStore
    const quizAvailable = !isEmpty(quiz)

    const { quizAttempts, pointsToPass, canBeRetaken, requiredToGoFurther } = quizAvailable && quiz

    const quizAttemptsLength = quizAttempts && quizAttempts.length
    // Get last attempt(saved as first on a server)
    const quizAttempt = !!quizAttemptsLength && quizAttempts[0]
    const quizSuccess = quizAttempt.status === QUIZ_ATTEMPT_STATUSES.completed
    const quizFailed = quizAttempt.status === QUIZ_ATTEMPT_STATUSES.failed

    const quizPointsGainedClasses = classNames('quiz-points__gained', {
      'quiz-points__gained--success': quizSuccess,
    })

    const { gainedPoints } = !!quizAttempt && quizAttempt

    const continueCourseButtonProps = {
      onClick: continueCourse,
      children: I18n.t('react.payer.course.continueCourse'),
    }
    const seeResultsButtonProps = {
      onClick: toggleQuizResults,
      children: I18n.t('react.payer.common.seeResults'),
    }
    const tryAgainButtonProps = {
      onClick: handleRetakeQuiz,
      children: I18n.t('react.payer.common.tryAgain'),
    }

    const seeResultsButton = <EloOrCustomButton defaultTheme={defaultTheme} {...seeResultsButtonProps} />
    const continueCourseBtn = <EloOrCustomButton defaultTheme={defaultTheme} {...continueCourseButtonProps} />
    const tryAgainButton = <EloOrCustomButton defaultTheme={defaultTheme} {...tryAgainButtonProps} />

    const hasGoToFurtherMark = requiredToGoFurther ? I18n.t('react.payer.quiz.your_next_lesson_is_closed') : ''

    let failButtons

    if (quizFailed) {
      failButtons = canBeRetaken ? (
        <Fragment>
          {tryAgainButton}
          {continueCourseBtn}
        </Fragment>
      ) : (
        <Fragment>
          <EloOrCustomButton
            defaultTheme={defaultTheme}
            {...{
              ...seeResultsButtonProps,
              orange: defaultTheme,
            }}
          />
          {continueCourseBtn}
        </Fragment>
      )
    }

    return (
      <EloModal
        isOpen
        className='quiz-result-modal'
        size={SIZES.small}
        title={quizSuccess ? I18n.t('react.payer.quiz.quizCompleted') : I18n.t('react.payer.quiz.quizFailed')}
        toggle={toggleQuizResultModal}
        cancel={false}
      >
        {quizzesStore.loading ? (
          <LoadingSpinner size={SIZES.large} />
        ) : (
          <Fragment>
            <div className='fields-container fields-container--column'>
              {quizSuccess ? (
                <i className='quiz-result-modal__result-icon fas fa-smile' />
              ) : (
                <i className='quiz-result-modal__result-icon fas fa-frown' />
              )}

              <div className='quiz-points'>
                <span className={quizPointsGainedClasses}>{gainedPoints > 0 ? gainedPoints : 0}</span>
                <span className='quiz-points__separator'>/</span>
                <span className='quiz-points__all'>{pointsToPass}</span>
              </div>
              <div className='quiz-result-modal__description'>
                {quizSuccess ? I18n.t('react.payer.quiz.quizCompletedDescription') : hasGoToFurtherMark}
              </div>
            </div>

            <div className='elo-modal__bottom-buttons fields-container--center-align'>
              {failButtons}
              {quizSuccess && (
                <Fragment>
                  {seeResultsButton}
                  {continueCourseBtn}
                </Fragment>
              )}
            </div>
          </Fragment>
        )}
      </EloModal>
    )
  }
}

QuizResultModal.displayName = 'QuizResultModal'

export default QuizResultModal
